import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'number-11-small', 'IconNumber11Small', [["path",{"d":"M8 8h1v8","key":"svg-0"}],["path",{"d":"M14 8h1v8","key":"svg-1"}]]);